const isAndroid = (userAgent) => !!(userAgent && userAgent.match(/(Android);?[\s/]+([\d.]+)?/));

module.exports = isAndroid;
